import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface BroadcastApiConfigOptions extends ApiConfigOptions {}
export class BroadcastApiConfig extends Configuration {
  constructor(configOptions?: BroadcastApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
